import { render } from "./LinkName.vue?vue&type=template&id=cbb3c032"
import script from "./LinkName.vue?vue&type=script&lang=js"
export * from "./LinkName.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__